import { Injectable } from '@angular/core';

import { IBetslipSourcePageState, SourcePageType } from 'packages/sports/common/betslip/model/edit-mybet/edit-bet-init';

import { MyBetsListContext } from '../../my-bets-base/models/my-bets-viewmodels';
import { MarketUrlParam } from '../../navigation-core/url-helper.service';

@Injectable()
export class MyBetsSourcePageService {
    constructor() {}

    getSourcePageState(context: MyBetsListContext): IBetslipSourcePageState {
        if (context.isEventView && context.eventId !== undefined && context.eventName !== undefined) {
            return {
                pageType: SourcePageType.Event,
                options: {
                    eventId: context.eventId,
                    eventName: context.eventName,
                    market: MarketUrlParam.MyBets,
                },
            };
        }

        return {
            pageType: SourcePageType.MyBets,
            options: null,
        };
    }
}
